/* eslint-disable jira/filename-case */
export const RESOURCE_TYPE_DEVOPS_PROVIDERS = 'SOFTWARE_DEVOPS_PROVIDERS';
export const BITBUCKET_PROVIDER_ID = 'bitbucket';
export const BITBUCKET_PIPELINE_PROVIDER_ID = 'kRiZ7boFApjBINFF1L7wPrCa4iF8O6R9';
export const BITBUCKET_PIPELINE_PROVIDER_ID_STG = 'cOwtZiBfejjJAryJH0WPb1otsa4HrI1N';
